async function getSupportedDealTypes() {
  let dealerSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let digitalRetailingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let paymentOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'finance';
  const {
    leaseEnabled = false,
    cashDeal = false,
    defaultDealType = 'FINANCE'
  } = dealerSettings;

  // Finance, Cash Tab Default
  const supportedDealTypes = ['finance', 'cash'];
  let initialDealType = ['FINANCE', 'LEASE', 'CASH'].includes(defaultDealType) ? defaultDealType.toLowerCase() : 'finance'; // Check only for 3 deal types

  // Remove Cash Tab
  if (!cashDeal && digitalRetailingType === 'accelerate') {
    supportedDealTypes.pop(); // Remove cash deal if it is not enabled for accelerate
  }

  // Enable Lease Tab
  if (leaseEnabled) {
    supportedDealTypes.splice(1, 0, 'lease');
  }
  if (!(digitalRetailingType === 'psx') && supportedDealTypes.includes('lease')) {
    // privateSeller
    initialDealType = paymentOption; // paymentOption is either lease or finance
  }
  return {
    supportedDealTypes,
    initialDealType
  };
}
export { getSupportedDealTypes as default };
